import { BaseResource } from './base';
import {
  ReportFiltersDto,
  CommissionSummaryReportDto,
  RuleReportDto,
  CollaboratorReportDto,
  PromotionReportDto,
  PromotionReportFiltersDto,
} from '../models/commissions';
import { RequestOptions } from '../types';

export class CommissionReportsResource extends BaseResource {
  private basePath = 'commissions/reports';

  async getSummary(
    params?: ReportFiltersDto,
    options?: RequestOptions,
  ): Promise<CommissionSummaryReportDto> {
    return this.client.get<CommissionSummaryReportDto>(`${this.basePath}/summary`, params, options);
  }

  async getByRule(params?: ReportFiltersDto, options?: RequestOptions): Promise<RuleReportDto[]> {
    return this.client.get<RuleReportDto[]>(`${this.basePath}/by-rule`, params, options);
  }

  async getByCollaborator(
    params?: ReportFiltersDto,
    options?: RequestOptions,
  ): Promise<CollaboratorReportDto[]> {
    return this.client.get<CollaboratorReportDto[]>(
      `${this.basePath}/by-collaborator`,
      params,
      options,
    );
  }

  async getPromotionAnalytics(
    params?: PromotionReportFiltersDto,
    options?: RequestOptions,
  ): Promise<PromotionReportDto[]> {
    return this.client.get<PromotionReportDto[]>(`${this.basePath}/promotions`, params, options);
  }

  async exportToCSV(params?: ReportFiltersDto, options?: RequestOptions): Promise<Blob> {
    return this.client.get<Blob>(`${this.basePath}/export/csv`, params, options);
  }

  async getTrends(
    params?: ReportFiltersDto,
    options?: RequestOptions,
  ): Promise<{ date: string; commissions: number; contracts: number }[]> {
    return this.client.get<{ date: string; commissions: number; contracts: number }[]>(
      `${this.basePath}/trends`,
      params,
      options,
    );
  }

  async getTopPerformers(
    params?: ReportFiltersDto & { limit?: number },
    options?: RequestOptions,
  ): Promise<CollaboratorReportDto[]> {
    return this.client.get<CollaboratorReportDto[]>(
      `${this.basePath}/top-performers`,
      params,
      options,
    );
  }
}
